export const COMPANY_DETAIL_START = 'COMPANY_DETAIL_START';
export const COMPANY_DETAIL_SUCCESS = 'COMPANY_DETAIL_SUCCESS';
export const COMPANY_DETAIL_FAIL = 'COMPANY_DETAIL_FAIL';

export const CREATE_COMPANY_START = 'CREATE_COMPANY_START';
export const CREATE_COMPANY_SUCCESS = 'CREATE_COMPANY_SUCCESS';
export const CREATE_COMPANY_FAIL = 'CREATE_COMPANY_FAIL';

export const UPDATE_COMPANY_START = 'UPDATE_COMPANY_START';
export const UPDATE_COMPANY_SUCCESS = 'UPDATE_COMPANY_SUCCESS';
export const UPDATE_COMPANY_FAIL = 'UPDATE_COMPANY_FAIL';

export const UPLOAD_COMPANY_LOGO_START = 'UPLOAD_COMPANY_LOGO_START';
export const UPLOAD_COMPANY_LOGO_SUCCESS = 'UPLOAD_COMPANY_LOGO_SUCCESS';
export const UPLOAD_COMPANY_LOGO_FAIL = 'UPLOAD_COMPANY_LOGO_FAIL';

export const COMPANY_BRANCHES_START = 'COMPANY_BRANCHES_START';
export const COMPANY_BRANCHES_SUCCESS = 'COMPANY_BRANCHES_SUCCESS';
export const COMPANY_BRANCHES_FAIL = 'COMPANY_BRANCHES_FAIL';

export const UPDATE_BRANCH_START = 'UPDATE_BRANCH_START';
export const UPDATE_BRANCH_SUCCESS = 'UPDATE_BRANCH_SUCCESS';
export const UPDATE_BRANCH_FAIL = 'UPDATE_BRANCH_FAIL';

export const CREATE_BRANCH_START = 'CREATE_BRANCH_START';
export const CREATE_BRANCH_SUCCESS = 'CREATE_BRANCH_SUCCESS';
export const CREATE_BRANCH_FAIL = 'CREATE_BRANCH_FAIL';

export const DELETE_BRANCH_START = 'DELETE_BRANCH_START';
export const DELETE_BRANCH_SUCCESS = 'DELETE_BRANCH_SUCCESS';
export const DELETE_BRANCH_FAIL = 'DELETE_BRANCH_FAIL';

export const CREATE_DEPARTMENT_START = 'CREATE_DEPARTMENT_START';
export const CREATE_DEPARTMENT_SUCCESS = 'CREATE_DEPARTMENT_SUCCESS';
export const CREATE_DEPARTMENT_FAIL = 'CREATE_DEPARTMENT_FAIL';

export const UPDATE_DEPARTMENT_START = 'UPDATE_DEPARTMENT_START';
export const UPDATE_DEPARTMENT_SUCCESS = 'UPDATE_DEPARTMENT_SUCCESS';
export const UPDATE_DEPARTMENT_FAIL = 'UPDATE_DEPARTMENT_FAIL';

export const DELETE_DEPARTMENT_START = 'DELETE_DEPARTMENT_START';
export const DELETE_DEPARTMENT_SUCCESS = 'DELETE_DEPARTMENT_SUCCESS';
export const DELETE_DEPARTMENT_FAIL = 'DELETE_DEPARTMENT_FAIL';

export const DEPARTMENT_OF_BRANCH_START = 'DEPARTMENT_OF_BRANCH_START';
export const DEPARTMENT_OF_BRANCH_SUCCESS = 'DEPARTMENT_OF_BRANCH_SUCCESS';
export const DEPARTMENT_OF_BRANCH_FAIL = 'DEPARTMENT_OF_BRANCH_FAIL';
